module.exports = __webpack_public_path__ + "img/img_notice_test.5a3f1890.jpg";